import { Filter } from "./filter";
import { ResourceTypes } from "./resourceTypes";

enum ResourcesListingSort {
  Default = "DEFAULT",
  Name = "NAME",
  Role = "ROLE",
  CreationDate = "CREATION_DATE",
}

type ResourcesListingFilter = Filter & {
  page: number;
  size: number;
  resourceTypes?: ResourceTypes[];
  inactiveOnly?: boolean;
  // Only the activated resources, never with inactiveOnly.
  activeOnly?: boolean;
  sort?: ResourcesListingSort;
  // Part of the resource name, searched by the back.
  name?: string;
};

const resourcesListingFilter: ResourcesListingFilter = {
  page: 0,
  size: 50,
};

export type { ResourcesListingFilter };

export { resourcesListingFilter, ResourcesListingSort };
